<template>
    <div class="upgrades-tile d-flex flex-column">
        <UpgradeRows v-if="expectedParticipants || participants.length > 0" :participants="participants"
            :expected-participants="expectedParticipants" @upgrade-changed="onUpgradeChanged" />
    </div>
</template>

<script setup>
import UpgradeRows from "@/components/classroom/sidePanel/upgrades/UpgradeRows.vue";

const props = defineProps({
    participants: Object,
    expectedParticipants: Object
});

const emit = defineEmits(['upgradeChanged']);

function onUpgradeChanged(data) {
    emit('upgradeChanged', data);
}

</script>

<style lang="scss">
@import '@/styles/variables.scss';

.upgrades-tile {
    padding: 2vh;
}
</style>